import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { updateSupplierAcknowledgementMutations } from "@/app/Suppliers/GraphQL/supplierAcknowledgementMutations";
import { UpdateSupplierAcknowledgementInput } from "@/gql/graphql";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { supplierAcknowledgementRecord } from "@/app/Suppliers/GraphQL/supplierAcknowledgementList";
import { SupplierAcknowledgementForm } from "@/app/Suppliers/Forms/SupplierAcknowledgementForm";

export function SupplierAcknowledgementUpdateDialog({
  supplierAcknowledgementId,
}: {
  supplierAcknowledgementId: string;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(
    updateSupplierAcknowledgementMutations,
  );
  const { data } = useSuspenseGqlQuery(supplierAcknowledgementRecord, {
    id: supplierAcknowledgementId,
  });

  return (
    <BaseDialog title="Update Acknowledgement">
      <GenericForm<UpdateSupplierAcknowledgementInput>
        initialValues={{
          name: data.supplierAcknowledgement.name,
          acknowledgement: data.supplierAcknowledgement.acknowledgement,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: supplierAcknowledgementId,
            input: values,
          });
          await close();
        }}
      >
        <SupplierAcknowledgementForm />
        <DialogSubmitButton text={"Update Acknowledgement"} />
      </GenericForm>
    </BaseDialog>
  );
}
